import { getPanelBrands } from 'common/api/productsSunwise';

import {
    FETCH_PANEL_BRANDS,
    FETCH_PANEL_BRANDS_FAILURE,
    FETCH_PANEL_BRANDS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_PANEL_BRANDS]());

    getPanelBrands()
        .then((response) =>
            dispatch(actions[FETCH_PANEL_BRANDS_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                actions[FETCH_PANEL_BRANDS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
